var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 9.82935C12.2655 9.82935 14.1022 8.00185 14.1022 5.74768C14.1022 3.49352 12.2663 1.66602 9.99967 1.66602C7.73301 1.66602 5.89717 3.49352 5.89717 5.74768C5.89717 8.00185 7.73301 9.82935 9.99967 9.82935ZM12.1363 11.5302H7.86301C5.38467 11.5302 3.33301 13.571 3.33301 16.0368C3.33301 16.6319 3.58967 17.1427 4.10217 17.3977C4.87134 17.8227 6.58051 18.3327 9.99967 18.3327C13.4188 18.3327 15.128 17.8227 15.8972 17.3977C16.1305 17.255 16.3236 17.0551 16.4582 16.817C16.5928 16.5789 16.6644 16.3104 16.6663 16.0368C16.6663 13.486 14.6155 11.5302 12.1363 11.5302Z",
    fill: "#CCAA65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBlue);
export default __webpack_public_path__ + "static/media/ProfileBlue.47f14018cd27699e35526caf3a18fea5.svg";
export { ForwardRef as ReactComponent };